import styled from 'styled-components';

export const Container = styled.div`
  height: 80px;
  padding: 0 30px;
  background: #3B5BFD;
  color: #FFF;
  display: flex;
  align-items: center;
`;
